import React from 'react';
import './NewsletterSection.css';
import ChairImage from '../components/assets/images/contact.png'; 


const NewsletterSection = () => {
  return (
    <section className="newsletter-section">
      <div className="newsletter-content">
        <div className="newsletter-left">
          <img src={ChairImage} alt="Chair" className="newsletter-image" />
        </div>
        <div className="newsletter-right">
          <h2>
            Get <span>20%</span> Off Discount Coupon
          </h2>
          <p>by Subscribe our Newsletter</p>
          <form className="newsletter-form">
            <input type="email" placeholder="Email Address" />
            <button type="submit">Get the Coupon</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
